import "dayjs/locale/ja";
import "dayjs/locale/en";
import "dayjs/locale/vi";
import "dayjs/locale/my";
import "dayjs/locale/id";
import "dayjs/locale/km";
import "dayjs/locale/mn";
import "dayjs/locale/ne";
import "dayjs/locale/th";
import "dayjs/locale/tl-ph";

import { jaJP, enUS, viVN } from "@mui/x-date-pickers/locales";
import { SupportedLanguage } from "@/constants/languages";

export const DAYJS_LOCALE_MAP: Record<SupportedLanguage, string> = {
  ja: "ja",
  en: "en",
  vi: "vi",
  my: "my",
  id: "id",
  km: "km",
  mn: "mn",
  ne: "ne",
  th: "th",
  tl: "tl-ph",
};

type MuiPickersLocale = typeof jaJP;

export const MUI_LOCALE_MAP: Record<SupportedLanguage, MuiPickersLocale> = {
  ja: jaJP,
  en: enUS,
  vi: viVN,
  my: enUS,
  id: enUS,
  km: enUS,
  mn: enUS,
  ne: enUS,
  th: enUS,
  tl: enUS,
};

export const getMuiLocaleText = (lang: SupportedLanguage) => {
  return MUI_LOCALE_MAP[lang].components.MuiLocalizationProvider.defaultProps.localeText;
};
